export const REQUEST_USER_REGISTER = 'REQUEST_USER_REGISTER';
export const FAILURE_USER_REGISTER = 'FAILURE_USER_REGISTER';
export const FAILURE_USER_REGISTER_EMAIL = 'FAILURE_USER_REGISTER_EMAIL';
export const SUCCESS_USER_REGISTER = 'SUCCESS_USER_REGISTER';
